import { t } from "i18next";

export const hasPermissionDataUser = (permissionsData, permission) => {
  return permissionsData?.roles
    ?.flatMap((item) => item?.permissions?.map((subItem) => subItem.code))
    ?.includes(permission);
};

export const USER_TYPE = {
  STAFF: "STAFF",
  PARTNER_STAFF: "PARTNER_STAFF",
};

export const USER_TYPE_OPTIONS = [
  { label: t("account.userTypeStaff"), value: USER_TYPE.STAFF },
  { label: t("account.userTypeAnyStaff"), value: USER_TYPE.PARTNER_STAFF },
];
